//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../GeometricUtilities/GeometricUtilities.SimpleDraft.js";
import "../no/Expression.js";
import "../no/Features.js";
import "../no/Expression.js";
let d=[[[1,"BackDraftAngle",0,"Expression",0],[0,"DraftOption",1,0],[1,"FrontDraftAngle",0,"Expression",0]],[[["section","n_drafts"],"GetDrafts",{R_:{drafts:"Features.EmbossTaper[]"}},1,0],[[],"GetAngleOption",{R_:{type:''}},0,0],[["type"],"SetAngleOption",{},1,0]],[]];
SPLM.GeometricUtilities.MultiDraft = class extends SPLM.GeometricUtilities.SimpleDraft{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.MultiDraft";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.MultiDraft.AngleOption = Object.freeze({
    "Single" : "Single", "Multiple" : "Multiple"});

export default SPLM;